// Création de l'objet à envoyer au back
const formaterFichierAutorisationDetentionArme = async (dataForm) => {
    return dataForm.autorisationDetentionArme
        ? dataForm.autorisationDetentionArme[0].getFileToSend()
        : null;
};

export default formaterFichierAutorisationDetentionArme;
